import { Backdrop } from '@mui/material';
import React from 'react';

/**
 * Invisible click/interaction blocker shown while a panel is fetching.
 *
 * Used by 27+ consumers across customer settings, structure cards,
 * dialogs, etc. Previously rendered a dark dimming overlay with a
 * spinner; now it's just a transparent Backdrop that blocks
 * interaction without any visual content.
 *
 * Visible loading feedback comes from elsewhere (the route-level
 * loader, button spinners, or context-specific skeletons inside the
 * panel that's loading). LoadingScreen's only job is to prevent
 * users from interacting with stale content during a fetch.
 */
function LoadingScreen() {
  return (
    <Backdrop
      open
      sx={{
        zIndex: theme => theme.zIndex.drawer + 1,
        bgcolor: 'transparent',
      }}
    />
  );
}

export default LoadingScreen;
